import React from 'react';
import { ProfileCatalogProduct } from '@/types';
import { toggleValue } from '@ygtechnologies/rubus-frontend-utilities';
import { NoResultsCard } from '@/components/Cards';
import { useCanScroll } from '@/utils/hooks';
import { ProductCard, ProductCardList } from '../products/ProductCard';
import ScrollToWrapper from '@/components/ScrollToWrapper';
import { Dropdown } from '@ygtechnologies/rubus-ui';
import { faCopy, faEdit, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { SimplePriceDisplay } from '../products/PriceDisplay';

interface CatalogProductListProps {
    checkedProductIds?: number[];
    products: ProfileCatalogProduct[];
    defaultSelectedId?: number;
    onCheckChange?(products: ProfileCatalogProduct[]): void;
    onEditClick(item: ProfileCatalogProduct): void;
    onDuplicateClick(item: ProfileCatalogProduct): void;
    onDeleteClick(item: ProfileCatalogProduct): void;
}

export const CatalogProductList: React.FC<CatalogProductListProps> = ({
    products,
    onEditClick,
    onDeleteClick,
    onCheckChange,
    checkedProductIds,
    defaultSelectedId,
    onDuplicateClick,
}) => {
    // const [checkedProductIds, setCheckedProductIds] = useState<number[]>([]);
    const canScroll = useCanScroll(defaultSelectedId);
    const onProductCheckChange = (product: ProfileCatalogProduct, checked: boolean) => {
        if (onCheckChange && checkedProductIds) {
            const checkedProducts = products.filter((x) => checkedProductIds.includes(x.id));
            onCheckChange(toggleValue(checkedProducts, product, checked));
        }
    };
    return (
        <div>
            <ProductCardList>
                {products.map((p) => (
                    <ScrollToWrapper key={p.id} shouldScroll={canScroll && defaultSelectedId === p.id}>
                        <ProductCard
                            catalog="profile"
                            product={p}
                            onCheckChange={onCheckChange ? onProductCheckChange : undefined}
                            checked={checkedProductIds ? checkedProductIds.includes(p.id) : false}
                            priceElement={<SimplePriceDisplay currencyMode="profile" finalPrice={p.defaultPrice || 0} />}
                            dropdownContent={
                                <>
                                    <Dropdown.Item icon={faEdit} onClick={(e) => onEditClick(p)}>
                                        <Trans>Edit</Trans>
                                    </Dropdown.Item>
                                    <Dropdown.Item icon={faCopy} onClick={(e) => onDuplicateClick(p)}>
                                        <Trans>Duplicate</Trans>
                                    </Dropdown.Item>
                                    <Dropdown.Item icon={faTrashAlt} onClick={(e) => onDeleteClick(p)}>
                                        <Trans>Delete</Trans>
                                    </Dropdown.Item>
                                </>
                            }
                        />
                    </ScrollToWrapper>
                ))}
            </ProductCardList>

            {products.length === 0 && <NoResultsCard />}
        </div>
    );
};
